<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="initHomeworkManageTeaData()"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">课程管理&gt;</div>
      </div>
      <div class="body_content">
        <div class="lesson_top">
          <button type="button" class="btn btn-default report_lesson" data-toggle="modal" data-target="#myModal">
            <img src="../assets/img/right/courseManageTea/teacher_pc_+_pro.png" style="margin-right: 5px">报课
          </button>
        </div>

        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content query-modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">{{option_flag=="add"?'新增':'编辑'}}课程</h4>
              </div>
              <div class="modal-body query-modal-lesson">
                <label>课程名称：</label>
                <input type="text" v-validate="'required|maxL:80'" data-vv-scope="course" data-vv-as="课程名称" name="name" class="form-control lesson_name" v-model="course.name"/>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('course.name') }}</span>


                <label class="course_type_label">课程类型：</label>
                <select class="form-control course_type" v-validate="'required|maxL:80'" data-vv-scope="course" data-vv-as="课程类型" name="type" v-model="course.type">
                  <option value="">选择课程类型</option>
                  <option v-for="(courseType, key, index) in course_type" :value="key">{{courseType}}</option>
                </select>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('course.type') }}</span>

                <label>　　课时：</label>
                <input type="number" v-validate="'required|maxL:80'" data-vv-scope="course" data-vv-as="课时" name="takeHours" class="form-control lesson_name" v-model="course.takeHours"/>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('course.takeHours') }}</span>

                <label>描述：</label>
                <textarea class="form-control description-textarea" placeholder="描述" rows="10" v-model="course.description" style="resize: none"></textarea>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default okBtn" @click="addLesson()">确定</button>
                <button type="button" class="btn btn-default okBtn" data-dismiss="modal" @click="">取消</button>
              </div>
            </div>
          </div>
        </div>

 <!--       <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content query-modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">增加课程</h4>
              </div>
              <div class="modal-body query-modal-lesson">
                <label>课程名称：</label>
                <input type="text" v-validate="'required|maxL:80'" data-vv-scope="course" data-vv-as="课程名称" name="courseName" class="form-control lesson_name" v-model="new_lessonMsg.new_lessonName"/>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('course.courseName') }}</span>


                <label class="course_type_label">课程类型：</label>
                <select class="form-control course_type" v-validate="'required|maxL:80'" data-vv-scope="course" data-vv-as="课程类型" name="courseType" v-model="new_lessonMsg.new_courseType">
                  <option value="">选择课程类型</option>
                  <option v-for="(courseType, key, index) in course_type" :value="key">{{courseType}}</option>
                </select>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('course.courseType') }}</span>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default okBtn" @click="addLesson()">确定</button>
                <button type="button" class="btn btn-default okBtn" data-dismiss="modal" @click="">取消</button>
              </div>
            </div>
          </div>
        </div>-->

        <div class="classList_div">
          <table class="table table-striped les_tabShow lesson_tab">
            <thead>
            <tr>
              <th width="20%">课程名称</th>
              <th width="20%">课程类型</th>
              <th width="20%">课程状态/开课状态</th>
              <th width="150px">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(lessonOne, index) in lessonList" :key="index">
              <td width="20%" class="tabTd_content_ellipsis">{{lessonOne.name}}</td>
              <td width="20%">{{lessonOne.type | formatType}}</td>
              <td width="20%">{{lessonOne.status|formatStatus}}/{{lessonOne.teacherStatus|formatTeacherStatus}}</td>
              <td width="150px">
                <button type="button" v-if="lessonOne.status == 1 && lessonOne.teacherStatus==1" class="btn btn-default cancel_lesson" @click="updateReportLesson(lessonOne.teacherId)">取消报课</button>

                <button type="button" v-if="lessonOne.status == 0 && lessonOne.teacherStatus==-1" class="btn btn-default delete_lesson" @click="deleteLessonId=lessonOne.id;deleteSchoolWorkById()">删除</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';
  import dictionaryData from '../json/dictionary';

  export default {
    name: "courseManageTea",
    data() {
      return {
        //课程列表
        lessonList: [],

        token: this.$store.state.access_token,
        userId: this.$store.state.userId,

        //课程
        course: {
          description: "",
          id: "",
          name: "",
          status: "0",
          takeHours: 4,
          type: "1"
        },
        option_flag:"",
        deleteLessonId: '',
        //课程类型
        course_type: dictionaryData.course_type,

        //当前选中课程类型
        activeType:'',

      }
    },
    filters: {
      formatType(value){
        let this_ = this;
        if(dictionaryData.course_type && value){
          value = dictionaryData.course_type[value];
        }
        return value;
      },
      formatStatus(value){
        let this_ = this;
        if(dictionaryData.check_status && value){
          value = dictionaryData.check_status[value];
        }
        return value;
      },
      formatTeacherStatus(value){
        let this_ = this;
        if(dictionaryData.course_teacher_status && value){
          value = dictionaryData.course_teacher_status[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.closeModal();
        this_.initLessonListData();
      });
    },
    methods: {
      /**
       * 初始加载数据
       */
      initLessonListData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'course/listByTeacher',
          params: {
            "teacherId":this_.userId
          }
        }).then(function (resp) {
          //课程记录
          let lessonData = resp.data;
          if(lessonData.success){
            this_.lessonList = lessonData.list;
          }
        })
      },
      /**
       * 新增课程
       */
      addLesson(){
        let this_ = this;
        this_.$validator.validateAll('course').then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'course/addRp',
              data: this_.course
            }).then(function (resp) {
              let data = resp.data;
              if(data.success){
                $("#myModal").modal("hide");
                // "保存成功".showMessage();
                this_.initLessonListData();
              }else{
                (data.message||"保存失败").showMessage();
              }
            })
          }
        });
      },
      /**
       * 删除课程
       */
      deleteSchoolWorkById(){
        let this_=this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'course/delete/' + this_.deleteLessonId,
            params: {}
          }).then(function (response) {
            this_.initLessonListData();
          });
        })
      },
      /**
       * 更新报课状态
       */
      updateReportLesson(id){
        let this_ = this;
          "确定取消报课".showConfirm(function () {
            schoolAxios({
              method: 'put',
              url: 'course/updateTeacherStatus',
              data: {
                id: id,
                status: 0,
              }
            }).then(function (resp) {
              let data = resp.data;
              if(data.success){
                "取消报课成功".showMessage();
                this_.initLessonListData();
              }else {
                "取消报课失败".showMessage();
              }
            });
          });
      },
      chooseType(course_type){
        let this_ = this;
        this_.new_lessonMsg.new_courseType = course_type;
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $('#myModal').on('hide.bs.modal', function () {
          this_.course = {
            description: "",
            id: "",
            name: "",
            status: "0",
            takeHours: 4,
            type: "1"
          };

          setTimeout(function () {
            this_.errors.clear('course');
          });

        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";

  .classList_div {
    position: relative;
    top: 2%;
    width: 100%;
    height: 86%;
    overflow: auto;
  }
  .les_tabShow {
    margin: 0 0 0 0;
    width: 100%;
    max-height: 100%;
    /* table-layout: fixed;*/
  }
  .les_tabShow tr {
    /*border-bottom: 1px grey solid;*/
    height: 50px;
  }
  .les_tabShow tr td{
    border: 0px;
    line-height: 32px;
  }
  .tabTd_content_ellipsis {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    -moz-text-overflow: ellipsis;
  }
  .lesson_tab tr th {
    background-color: #cccccc;
    color: black;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
  }
  .lesson_tab tr td {
    text-align: center;
    font-size: 16px;
  }
  .lesson_tab tbody {
    /*height: 600px;*/
    font-weight: bold;
  }

  .havenClick {
    background-color: #ff6f66;
  }
  .report_lesson,.delete_lesson {
    width: 50px;
    height: 30px;
    border-radius: 20px;
    line-height: 15px;
    font-size: 15px;
    font-weight: bold;
  }
  .cancel_lesson {
    height: 30px;
    border-radius: 20px;
    line-height: 10px;
    font-size: 15px;
    font-weight: bold;
  }
  button.btn.btn-default.cancel_lesson {
    width: 200px;
  }
  button.btn.btn-default.report_lesson {
    width: 95px;
  }
  button.btn.btn-default.delete_lesson {
    width: 95px;
  }


  .btn-default {
    width: 140px;
    height: 30px;
    border-radius: 5px;
  }
  .okBtn {
    width: 50px;
    line-height: 0px;
  }
  .lesson_top {
    margin: 20px 0 0 0;
  }
  .lesson_name {
    display: unset;
  }
  .course_type_div {
    margin: 0px 0 0 75px;
    float: right;
  }
  .course_type_btn {
    width: 80px;
    height: 25px;
    border-radius: 20px;
    margin: 2px 6px;
    line-height: 10px;
  }
  .course_type {
    display: unset;
  }

  .course_type_label {
    float: left;
    margin: 4% 0 0 0;
  }
  .modal-body.query-modal-lesson {
    /*height: 220px;*/
  }
  .query-modal-lesson label {
    margin: 10px 0 0 0;
  }
  .query-modal-lesson input {
    width: 80%;
  }

  .query-modal-lesson select {
    width: 280px;
    margin: 5px 0 0 3px;
  }

</style>



// WEBPACK FOOTER //
// src/components/courseManageTea.vue